import toastr from 'toastr'
import 'toastr/toastr.scss'

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: 'toast-bottom-left',
  preventDuplicates: false,
  onclick: null,
  showDuration: '300',
  hideDuration: '300',
  timeOut: '8000',
  extendedTimeOut: '4000',
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut'
}

const DEFAULT_MESSAGE_TYPE = 'info'
const types = new Set([
  'success',
  'info',
  'warning',
  'error'
])

const show = (type, text) => {
  if (!types.has(type)) {
    type = DEFAULT_MESSAGE_TYPE
  }
  return toastr[type](text)
}

const clear = () => toastr.clear()
const remove = () => toastr.remove()
const error = (text) => show('error', text)
const success = (text) => show('success', text)

export {
  show,
  success,
  error,
  remove,
  clear
}
